import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App.vue'
import http from './http' //axios实例化后引入取名http
import router from './router'
import store from './store'

Vue.use(ElementUI)
Vue.prototype.$http = http //放入全局
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
